import React from "react";
import "../main.css";
import { PrimaryCTAHyperlink } from "../../components/PrimaryCTA";
import {
    Button,
    Grid,
    GridColumn,
    GridRow,
    Segment,
    Tab,
} from "semantic-ui-react";
import ResultsTable from "./ResultsTable";
import ResultsList from "./ResultsList";
import { ReactComponent as WarningIcon } from "../assets/alert-warning.svg";
import { ReactComponent as SuccessIcon } from "../assets/success-circle.svg";
import Cookies from "js-cookie";

export default class ResultsPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sheets: this.props.singleResponse.sheets,
            visibleSheet: this.props.singleResponse.sheets[0].name,
        };
    }

    isWeekValidationResultPassed(sheetName) {
        let sheet = this.state.sheets.find(
            sheetElement => sheetElement.name === sheetName
        );

        let allFieldsPassed = true;

        try {
            sheet.students.map(details => {
                details.fields.map(result => {
                    if (result.validationResult === "FAILED") {
                        allFieldsPassed = false;
                    }
                });
            });
        } catch (e) {
            console.log(e);
        }

        return allFieldsPassed;
    }

    handleWeekSelection = week => {};

    render() {
        let sheetNames = this.props.singleResponse.sheets.map(
            sheetElement => sheetElement.name
        );

        return (
            <>
                <Grid divided className="results-layout">
                    <GridColumn width={13} textAlign="left">
                        <GridRow className="results-file-name pb-3">
                            {this.props.selectedFile.name}
                        </GridRow>
                        <GridRow>
                            <p>
                                Once you've updated any errors, you can upload
                                another sheet to check it again.
                            </p>
                        </GridRow>
                    </GridColumn>
                    <GridColumn width={2} textAlign="center">
                        <GridRow className="pb-1">
                            <p>Happy with your sheet?</p>
                        </GridRow>
                        <GridRow>
                            <PrimaryCTAHyperlink
                                type="button"
                                href={
                                    "/programme-setup/pupil-information/?id=" +
                                    Cookies.get("programmeId")
                                }
                                style={{
                                    fontFamily: "Modelica",
                                    fontWeight: 800,
                                }}
                            >
                                RETURN TO PORTAL
                            </PrimaryCTAHyperlink>
                        </GridRow>
                    </GridColumn>
                </Grid>
                <Grid
                    className="results-layout"
                    style={{ backgroundColor: "#f9f8fb" }}
                >
                    <GridColumn width={3}>
                        <ResultsList
                            groupedResponse={this.props.groupedResponse}
                        />
                    </GridColumn>
                    <GridColumn width={13}>
                        <GridRow>
                            <ResultsTable
                                formData={this.props.singleResponse}
                                sheetToRender={this.state.visibleSheet}
                            />
                        </GridRow>
                        <GridRow className="mt-2 button-group">
                            <Button.Group widths={sheetNames.length}>
                                {sheetNames.map(sheetName => {
                                    return (
                                        <Button
                                            active={
                                                this.state.visibleSheet ===
                                                sheetName
                                            }
                                            onClick={() =>
                                                this.setState({
                                                    visibleSheet: sheetName,
                                                })
                                            }
                                            className={
                                                "weekBtn " +
                                                (this.state.visibleSheet ===
                                                sheetName
                                                    ? "weekBtnVisibleSheet "
                                                    : "")
                                            }
                                        >
                                            <span>
                                                {this.isWeekValidationResultPassed(
                                                    sheetName
                                                ) ? (
                                                    <SuccessIcon />
                                                ) : (
                                                    <WarningIcon />
                                                )}
                                            </span>
                                            <span
                                                style={{
                                                    paddingLeft: "0.5em",
                                                    fontFamily: "Modelica",
                                                    fontWeight: 800,
                                                    verticalAlign: "text-top",
                                                }}
                                            >
                                                {sheetName}
                                            </span>
                                        </Button>
                                    );
                                })}
                            </Button.Group>
                        </GridRow>
                    </GridColumn>
                </Grid>
            </>
        );
    }
}
